// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as LbUtils from "./LbUtils.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as InfoTooltip from "../components/InfoTooltip.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as LbPlayerName from "./LbPlayerName.bs.js";
import * as LbTypeSelect from "./LbTypeSelect.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as LbPlayerSearch from "./LbPlayerSearch.bs.js";
import * as UnitAutocomplete from "./UnitAutocomplete.bs.js";
import FormatDistanceToNow from "date-fns/formatDistanceToNow";

var cols = [
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Rank");
        }), undefined, (function (v, param, param$1) {
          return String(v.num + 1 | 0);
        }), undefined, undefined, undefined, undefined, undefined, 74, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("Name");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(LbPlayerName.make, {
                      region: Region.fromApiName(v.region),
                      playerName: v.name,
                      companionId: v.companionId
                    });
        }), "flex items-center overflow-hidden", undefined, undefined, undefined, undefined, 224, (function (v) {
          return Route.toString({
                      TAG: /* Player */2,
                      _0: {
                        region: Region.fromApiName(v.region),
                        playerName: v.name,
                        tag: undefined,
                        match: undefined
                      }
                    });
        }), undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Mastery");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(0, v.rating);
        }), undefined, undefined, undefined, undefined, undefined, 104, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("LP");
        }), "pl-[52px]", (function (v, param, param$1) {
          var match = v.rank;
          return React.createElement(React.Fragment, undefined, React.createElement("img", {
                          className: "my-[-2px]",
                          height: "30",
                          src: "https://ap.tft.tools/img/banner/" + match[0].toLowerCase() + "_solo.png?width=30",
                          width: "30"
                        }), React.createElement("div", {
                          className: "pl-[6px]"
                        }, String(match[2]) + "LP"));
        }), "items-center", undefined, undefined, undefined, undefined, 124, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Games");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps"
                        }, String(v.patchGames)), React.createElement("div", {
                          className: "lb-ss"
                        }, String(v.games)));
        }), undefined, undefined, undefined, undefined, undefined, 84, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps"
                        }, v.patchGames === 0 ? "-" : Global.toFixed(undefined, v.patchAvgPlace)), React.createElement("div", {
                          className: "lb-ss"
                        }, Global.toFixed(undefined, v.avgPlace)));
        }), undefined, undefined, undefined, undefined, undefined, 84, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps"
                        }, v.patchGames === 0 ? "-" : Global.formatPct(undefined, Global.f(v.patchTop4) / Global.f(v.patchGames)) + "%"), React.createElement("div", {
                          className: "lb-ss"
                        }, Global.formatPct(undefined, Global.f(v.top4) / Global.f(v.games)) + "%"));
        }), undefined, undefined, undefined, undefined, undefined, 84, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "lb-ps"
                        }, v.patchGames === 0 ? "-" : Global.formatPct(undefined, Global.f(v.patchWon) / Global.f(v.patchGames)) + "%"), React.createElement("div", {
                          className: "lb-ss"
                        }, Global.formatPct(undefined, Global.f(v.won) / Global.f(v.games)) + "%"));
        }), undefined, undefined, undefined, undefined, undefined, 82, undefined, undefined)
];

function LbUnit$Inner(Props) {
  var unitId = Props.unitId;
  var data = Props.data;
  TftSet.use(undefined);
  var unitsT = Translation.useT(/* Units */1);
  var initUnit = React.useRef(unitId);
  var router = Router.use(undefined);
  React.useState(function () {
        
      });
  var data$1 = data[1];
  var lu = data[0];
  var lastUpdated = React.useMemo((function () {
          return new Date(lu);
        }), [lu]);
  var match = React.useState(function () {
        return false;
      });
  var usePatchStats = match[0];
  var renderElements = LbUtils.useRenderElements(undefined);
  var data$2 = React.useMemo((function () {
          return Belt_Array.slice(data$1, 0, renderElements);
        }), [
        renderElements,
        data$1
      ]);
  var keyFn = React.useCallback((function (d) {
          return d.region + " " + d.name;
        }), []);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(LbPlayerSearch.make, {}), React.createElement(LbTypeSelect.make, {
                  region: undefined,
                  typ: /* Unit */3
                }), React.createElement(ContentSection.make, {
                  className: "font-montserrat font-medium md:w-[880px]",
                  children: null,
                  noPadding: true
                }, React.createElement("div", {
                      className: "flex flex-col sm:flex-row justify-between sm:items-center px-4 py-3"
                    }, React.createElement("div", {
                          className: "flex items-center"
                        }, React.createElement("div", {
                              className: "pr-4"
                            }, "Select unit"), React.createElement("div", undefined, React.createElement("div", undefined, React.createElement(UnitAutocomplete.make, {
                                      onChange: (function (unitId) {
                                          return router.push(Route.toString({
                                                          TAG: /* Leaderboards */7,
                                                          _0: {
                                                            TAG: /* Unit */3,
                                                            _0: unitId
                                                          }
                                                        }), undefined, undefined);
                                        }),
                                      defaultValue: initUnit.current
                                    })))), React.createElement("div", {
                          className: "flex justify-between sm:justify-start pt-3 sm:pt-0"
                        }, React.createElement("div", {
                              className: "text-sm text-white2 pr-4"
                            }, "Updated " + FormatDistanceToNow(lastUpdated) + " ago"), React.createElement("div", {
                              className: "px-[2px]"
                            }, React.createElement(InfoTooltip.make, {
                                  children: React.createElement("div", {
                                        className: "leading-snug"
                                      }, "This table is sorted based on Mastery value that is calculated based on player's rank amount of games played and average place with when using the particular unit.")
                                })))), React.createElement("div", {
                      className: usePatchStats ? "lb-patch-stats" : "lb-season-stats"
                    }, React.createElement(StatsTable2.make, {
                          montserratHeader: true,
                          size: "lg",
                          cols: cols,
                          data: data$2,
                          context: undefined,
                          extraStickyHeader: React.createElement("div", {
                                className: "h-10 pl-3 flex items-center justify-between pt-1 pr-6 text-center"
                              }, React.createElement("div", {
                                    className: "flex items-center"
                                  }, React.createElement(UnitImage.make, {
                                        unitId: unitId,
                                        size: 26,
                                        showName: false
                                      }), React.createElement("div", {
                                        className: "pl-2 font-medium"
                                      }, "Top " + unitsT(unitId) + " players")), React.createElement(LbUtils.PatchStatsToggle.make, {
                                    usePatchStats: usePatchStats,
                                    setUsePatchStats: match[1]
                                  })),
                          keyFn: keyFn,
                          top: "t48"
                        }))));
}

var Inner = {
  make: LbUnit$Inner
};

function LbUnit(Props) {
  var unitId = Props.unitId;
  var data = Props.data;
  return React.createElement(LbUnit$Inner, {
              unitId: unitId,
              data: data
            });
}

var make = LbUnit;

export {
  cols ,
  Inner ,
  make ,
  
}
/* cols Not a pure module */
